import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const LogoIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color}>
      <path d="m94.699 44.801-7.3-4.898 3.898-7.899c.898-1.898.8-4-.2-5.8s-2.898-3-5-3.102l-8.8-.602-.602-8.699c-.102-2.102-1.3-3.898-3.102-5-1.8-1-4-1.102-5.8-.2L60 12.502 55.1 5.198c-2.3-3.398-8-3.5-10.3 0L39.998 12.5l-7.898-3.898c-1.898-.899-4-.801-5.8.199s-3 2.898-3.102 5l-.602 8.8-8.7.602c-2.1.102-3.898 1.301-5 3.102-1 1.8-1.1 4-.198 5.898l3.898 7.899L5.297 45c-1.7 1.2-2.802 3.102-2.802 5.2 0 2.101 1 4 2.801 5.199l7.301 4.898-3.898 7.898c-.899 1.899-.801 4.102.199 5.801 1 1.801 2.898 2.899 5 3.102l8.8.601.602 8.7c.102 2.101 1.301 3.898 3.102 5 1.8 1 4 1.101 5.8.199l7.899-3.899L44.999 95c1.2 1.7 3.102 2.801 5.2 2.801 2.101 0 4-1 5.199-2.8l4.898-7.302 7.899 3.899c1.898.898 4 .8 5.8-.2 1.801-1 3-2.898 3.102-5l.602-8.8 8.8-.602c2.102-.101 3.899-1.3 5-3.101 1-1.801 1.102-4 .2-5.801L87.499 60l7.301-4.898c1.7-1.2 2.801-3.102 2.801-5.2-.102-2.101-1.102-4.003-2.902-5.101zm-12.398 9.5c-2.602 1.7-3.5 5.102-2.102 7.898l3.5 7.102-7.898.5a6.235 6.235 0 0 0-5.8 5.8l-.5 7.9-7.102-3.5c-2.801-1.4-6.2-.5-7.899 2.1l-4.5 6.7-4.398-6.602c-1.2-1.8-3.2-2.8-5.2-2.8-.898 0-1.898.199-2.699.601l-7.101 3.5L30 75.602a6.235 6.235 0 0 0-5.8-5.801l-7.899-.5 3.5-7.102c1.398-2.8.5-6.199-2.102-7.898l-6.601-4.398 6.601-4.399c2.602-1.699 3.5-5.101 2.102-7.898l-3.5-7.102 7.898-.5a6.235 6.235 0 0 0 5.801-5.8l.5-7.899 7.102 3.5c2.8 1.398 6.199.5 7.898-2.102l4.399-6.601 4.398 6.601c1.7 2.602 5.102 3.5 7.898 2.102l7.102-3.5.5 7.898a6.235 6.235 0 0 0 5.8 5.801l7.9.5-3.5 7.102c-1.4 2.8-.5 6.199 2.1 7.898l6.602 4.399z" />
      <path d="M60 45.699c-.8-1.2-2.8-1.2-3.602 0l-3.398 5-6.398-9.3c-.801-1.2-2.801-1.2-3.602 0L31.602 58c-.5.7-.5 1.5-.102 2.301.399.7 1.102 1.2 1.899 1.2H66.5c.8 0 1.601-.4 1.898-1.2.399-.7.301-1.602-.101-2.3zM61.102 35.301c0 6.266-9.402 6.266-9.402 0s9.402-6.266 9.402 0" />
    </g>
  </svg>
);

LogoIcon.propTypes = propTypes;

export default LogoIcon;
